import { cloneDeep } from "lodash";

/** Community ECM rows are always active; normalize persisted / merged maps. */
export function setAllCommunityEcmMeasuresActive(ecmInputMap = {}) {
    const out = cloneDeep(ecmInputMap);
    Object.keys(out).forEach((cat) => {
        const upgrades = out[cat];
        if (!upgrades || typeof upgrades !== "object") return;
        Object.keys(upgrades).forEach((id) => {
            out[cat][id] = { ...out[cat][id], active: true };
        });
    });
    return out;
}

/**
 * Count non-"None" ECM rows and derive pass / fail labels for community validation UI.
 */
export function getCommunityMeasureValidationStats(ecmInputMap = {}, upgradePackages = {}) {
    let totalNonNone = 0;
    let passingCount = 0;
    const failingLabels = [];
    const unvalidatedLabels = [];

    const packageLabelForRow = (data, id) => {
        const upgradePackageName =
            upgradePackages.find(
                (upgradePackage) => upgradePackage.id === data?.packageValues?.upgradePackageId
            )?.name || "Package Not Found";
        return `${upgradePackageName} - ${data?.label || id}`;
    };

    Object.values(ecmInputMap).forEach((upgrades) => {
        if (!upgrades || typeof upgrades !== "object") return;
        Object.entries(upgrades).forEach(([id, data]) => {
            if (id === "None") return;
            totalNonNone += 1;
            if (data?.passed === true) {
                passingCount += 1;
            } else if (data?.passed === false) {
                failingLabels.push(packageLabelForRow(data, id));
            } else {
                unvalidatedLabels.push(packageLabelForRow(data, id));
            }
        });
    });

    return {
        totalNonNone,
        passingCount,
        failingLabels,
        unvalidatedLabels,
        measuresAllPassing: totalNonNone >= 1 && passingCount === totalNonNone,
    };
}

/**
 * Merge remote validation fields from Firestore into the local ecmInputMap without clobbering unsaved edits.
 */
export function mergeCommunityValidationEcmResults(local = {}, remote = {}) {
    const out = cloneDeep(local);
    Object.entries(remote).forEach(([cat, upgrades]) => {
        if (!upgrades || typeof upgrades !== "object") return;
        Object.entries(upgrades).forEach(([id, remoteEntry]) => {
            if (!out[cat]?.[id]) return;
            const { passed, individualSavings } = remoteEntry || {};
            out[cat][id] = {
                ...out[cat][id],
                ...(passed !== undefined ? { passed } : {}),
                ...(individualSavings !== undefined ? { individualSavings } : {}),
            };
        });
    });
    return out;
}
